import React, { Component } from 'react';
import axios from "axios";
import Swal from 'sweetalert2';

class InvolvedFrom extends Component {
    constructor() {
        super();
        this.state = {
            sectionName: '',
            SponsorCategory: '',
            vaideekam: '',

            name: '',
            age: '',
            phone: '',
            email: '',
            address1: '',
            address2: '',
            city: '',
            state: '',
            zipcode: '',
            PANno: '',
            amount: "",
            isdisableBtn: true,
            message: '',
            trnxNo: '',
            isvilated: false,
            Option_1: [
                { value: "", label: "--Select--" },
                { value: "Volunteer", label: "Volunteer" },
                { value: "ProvideFinancialSupport", label: "Provide Financial Support" },
                { value: "ContributeToAnnadanan", label: "Contribute to Annadanan" }
            ],
            Option_2: [
                { value: "", label: "--Select--" },
                { value: "GouDhanam", label: "GouDhanam" },
                { value: "DashaDhanam", label: "DashaDhanam" },
                { value: "Culturalprograms", label: "Culturalprograms" },

            ],
            Option_3: [
                { value: "", label: "--Select--" },
                { value: "Annadhanam", label: "Annadhanam" }
            ],
            SelectedOption_1: "",
            SelectedOption_2: ""
        };

    };

    // Handle input change
    handleInputChange = (e) => {

        const { name, value } = e.target;
        debugger;


        this.setState({ [name]: value }, () => {
            if (this.state.sectionName != "Volunteer") {
                this.props.accountInfo(true);
            } else {
                this.props.accountInfo(false);
            }

            if (this.state.isvilated) {
                this.validation();
            }

        });
    };
    handleSubmit = (e) => {
        e.preventDefault();
        if (this.validation()) {

            const { sectionName, SponsorCategory, vaideekam, name, age, phone, email, trnxNo, address1, address2, city, state, zipcode, PANno, amount } = this.state;

            // Create a FormData object to hold the data as form-data (multipart/form-data)
            const formData = new FormData();
            formData.append('sectionName', sectionName);
            formData.append('SponsorCategory', SponsorCategory);
            formData.append('vaideekam', vaideekam);

            formData.append('name', name);
            formData.append('age', age);
            formData.append('phone', phone);
            formData.append('email', email);
            formData.append('address1', address1);
            formData.append('address2', address2);
            formData.append('city', city);
            formData.append('state', state);
            formData.append('zipcode', zipcode);
            formData.append('PANno', PANno);
            formData.append('amount', amount);
            formData.append('trnxNo', trnxNo);

            axios.post('https://srkbst.org/api/involved.php', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            })
                .then((response) => {
                    console.log(response.data);
                    debugger;
                    if (response.status == 200) {
                        this.setState({
                            sectionName: '',
                            SponsorCategory: '',
                            name: '',
                            vaideekam: '',

                            age: '',
                            phone: "",
                            email: '',
                            address1: '',
                            address2: '',
                            city: '',
                            state: '',
                            zipcode: '',
                            PANno: '',
                            amount: "",
                            trnxNo: '',
                            isdisableBtn: true, isvilated: false
                        });
                        Swal.fire({
                            title: 'Success!',
                            text: 'Thank you for your submission.Look forward to your prayers for the Universal Peace.',
                            icon: 'success',
                            confirmButtonText: 'OK'
                        });


                        //alert(response.message);
                    } else {
                        alert('Failed to add contact: ' + response.message);
                    }
                })
                .catch((error) => {
                    console.error("Error:", error);
                });

        } else {
            alert('please fill all mandatory fields')
        }

    };

    validation = () => {

        let flag = true;
        if (this.state.sectionName == "") {
            flag = false;
        }
        if (this.state.sectionName != 'Volunteer') {
            if (this.state.SponsorCategory == '') {
                flag = false;
            }
            if (this.state.PANno == '') {
                flag = false;
            }
            if (this.state.amount == '') {
                flag = false
            }
        } else {
            if (this.state.vaideekam == '') {
                flag = false;
            }

        }


        if (this.state.name == '') {
            flag = false;
        }
        if (this.state.age == '') {
            flag = false;
        }
        if (this.state.phone == '') {
            flag = false;
        }
        if (this.state.email == '') {
            flag = false;
        }
        if (this.state.city == '') {
            flag = false;
        }
        if (this.state.state == '') {
            flag = false;
        }
        if (this.state.zipcode == '') {
            flag = false;
        }

        this.setState({ isdisableBtn: (flag == true ? true : false), isvilated: true })
        return flag
    }

    componentDidMount() {

    }
    render() {
        return (

            <>
                <h2>Get Involved</h2>
                <hr className='normal'></hr>
                <form className="forms-sample mt-4">
                    <div className='row'>
                        <div className='col-lg-6'>
                            <label for="option" className="form-label">I would like to: <span className='text-danger'>*</span></label>
                            <select className="form-select" name="sectionName" id="option" value={this.state.sectionName} required onChange={this.handleInputChange}>
                                {this.state.Option_1.map((item, index) => {
                                    return (
                                        <option value={item.value}>{item.label}</option>
                                    )
                                })}


                            </select>
                        </div>
                        {this.state.sectionName == "Volunteer" && <div className='col-lg-6 ps-lg-5'>
                            <label for="option" className='mb-3'>Be a volunteer Activities: <span className='text-danger'>*</span></label>
                            <div className='row'>
                                <div className="form-check col-lg-4">
                                    <input className="form-check-input" type="radio" name="vaideekam" checked={this.state.vaideekam == 'Vaideekam'} onChange={this.handleInputChange} value="Vaideekam" id="vaideekam"></input>
                                    <label className="form-check-label" for="flexRadioDefault1">Vaideekam
                                    </label>
                                </div>
                                <div className="form-check col-lg-4">
                                    <input className="form-check-input" type="radio" name="vaideekam" checked={this.state.vaideekam == 'Non Vaideekam'} onChange={this.handleInputChange} value="Non Vaideekam" id="nonVaideekam"></input>
                                    <label className="form-check-label" for="flexRadioDefault2">
                                        Non Vaideekam
                                    </label>

                                </div>
                                <div className="form-check col-lg-4">
                                    <input className="form-check-input" type="radio" name="vaideekam" checked={this.state.vaideekam == 'Athirudram_2026'} onChange={this.handleInputChange} value="Athirudram_2026" id="Athirudram_2026"></input>
                                    <label className="form-check-label" for="flexRadioDefault3">
                                        Athirudram 2026
                                    </label>

                                </div>
                            </div>

                        </div>
                        }



                        {this.state.sectionName != "" && (this.state.sectionName == "ProvideFinancialSupport") && <div className='col-lg-6 mb-3'>
                            <label for="SponsorCategory" className="form-label">Be a Sponsor <span className='text-danger'>*</span></label>
                            <select className="form-select" name="SponsorCategory" id="SponsorCategory" value={this.state.SponsorCategory} required onChange={this.handleInputChange}>
                                {this.state.Option_2.map((item, index) => {
                                    return (
                                        <option value={item.value}>{item.label}</option>
                                    )
                                })}
                            </select>
                        </div>}
                        {this.state.sectionName != "" && (this.state.sectionName == "ContributeToAnnadanan") && <div className='col-lg-6 mb-3'>
                            <label for="SponsorCategory" className="form-label">Be a Sponsor <span className='text-danger'>*</span></label>
                            <select className="form-select" name="SponsorCategory" id="SponsorCategory" value={this.state.SponsorCategory} required onChange={this.handleInputChange}>
                                {this.state.Option_3.map((item, index) => {
                                    return (
                                        <option value={item.value}>{item.label}</option>
                                    )
                                })}
                            </select>
                        </div>}
                    </div>

                    <div className='col-lg-6 mb-3'>
                        <label for="name" className="form-label">Name <span className='text-danger'>*</span></label>
                        <input type="text" className="form-control" id="name" name="name" value={this.state.name} required onChange={this.handleInputChange} />
                    </div>

                    <div className='col-lg-6 mb-3'>
                        <label for="age" className="form-label">Age: <span className='text-danger'>*</span></label>
                        <input type="number" className="form-control" id="age" name="age" value={this.state.age} onChange={this.handleInputChange} required />
                    </div>

                    <div className="mb-3">
                        <label for="addressLine1" className="form-label">Street Address Line 1 <span className='text-danger'>*</span></label>
                        <input type="text" className="form-control" id="addressLine1" name="address1" value={this.state.address1} required onChange={this.handleInputChange} />
                    </div>

                    <div className="mb-3">
                        <label for="addressLine2" className="form-label">Street Address Line 2</label>
                        <input type="text" className="form-control" id="addressLine2" name="address2" value={this.state.address2} onChange={this.handleInputChange} />
                    </div>




                    <div className="row g-3">
                        <div className={`mb-3 col-md-4`}>
                            <label for="phone" className="form-label">Ph: <span className='text-danger'>*</span></label>
                            <input type="tel" className="form-control" id="phone" name="phone" value={this.state.phone} onChange={this.handleInputChange} required />
                        </div>
                        <div className={`mb-3 col-md-4`}>
                            <label for="email" className="form-label">Email: <span className='text-danger'>*</span></label>
                            <input type="email" className="form-control" id="email" name="email" value={this.state.email} onChange={this.handleInputChange} required />
                        </div>
                        <div className="col-md-4">
                            <label for="city" className="form-label">City <span className='text-danger'>*</span></label>
                            <input type="text" className="form-control" id="city" name="city" value={this.state.city} required onChange={this.handleInputChange} />
                        </div>
                        <div className="col-md-6">
                            <label for="state" className="form-label">State / Province <span className='text-danger'>*</span></label>
                            <input type="text" className="form-control" id="state" name="state" value={this.state.state} required onChange={this.handleInputChange} />
                        </div>

                        <div className="col-md-6">
                            <label for="zipcode" className="form-label">Postal / Zip Code <span className='text-danger'>*</span></label>
                            <input type="text" className="form-control" id="zipcode" name="zipcode" value={this.state.zipcode} required onChange={this.handleInputChange} />
                        </div>

                        {(this.state.sectionName == "ProvideFinancialSupport" || this.state.sectionName == "ContributeToAnnadanan") && <div className="col-md-4">
                            <label for="PANno" className="form-label">PAN No <span className='text-danger'>*</span></label>
                            <input type="text" className="form-control" id="PANno" name="PANno" value={this.state.PANno} required onChange={this.handleInputChange} />
                        </div>}

                        {(this.state.sectionName == "ProvideFinancialSupport" || this.state.sectionName == "ContributeToAnnadanan") && <div className="col-md-4">
                            <label for="amount" className="form-label">Amount <span className='text-danger'>*</span></label>
                            <input type="text" className="form-control" id="amount" name="amount" value={this.state.amount} required onChange={this.handleInputChange} />
                        </div>}
                        {(this.state.sectionName == "ProvideFinancialSupport" || this.state.sectionName == "ContributeToAnnadanan") && <div className="col-md-4">
                            <label for="trnxNo" className="form-label">Transaction No.: </label>
                            <input type="text" className="form-control" id="trnxNo" name="trnxNo" value={this.state.trnxNo} onChange={this.handleInputChange} />
                        </div>}

                    </div>
                    {!this.state.isdisableBtn && <div className='col-12 col-lg-12'>
                        <span className='float-start text-start text-danger'>* All are Required</span>
                    </div>}
                    <div className="d-flex justify-content-center mt-4">

                        <button type="submit" className="btn btn-success me-2" onClick={this.handleSubmit} disabled={(!this.state.isdisableBtn && !this.state.isvilated)}>Submit</button>
                    </div>
                </form>
            </>



        );
    }
}

export default InvolvedFrom;
